import * as yup from 'yup';

const schema = yup.object().shape({
  email: yup
    .string()
    .email('Email inválido')
    .test('no-leading-trailing-spaces', 'Email não pode conter espaços no início ou fim', (value) => {
      if (!value) return true;
      return !/^\s|\s$/.test(value);
    })
    .required('Email é obrigatório')
});

export default schema;
